var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.162,
    height: 19.17,
    viewBox: "0 0 34.162 34.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8300",
    "data-name": "Group 8300",
    transform: "translate(16212.429 19313.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16050",
    "data-name": "Path 16050",
    d: "M330.242,34.911a43.95,43.95,0,0,0-.01-9.035H318.089v9.035ZM318.516,23.481H329.9a22.2,22.2,0,0,0-2.732-7.935c-1.836-2.958-4.079-2.965-5.914-.015a21.925,21.925,0,0,0-2.737,7.949M318.5,37.257c.123.623.224,1.207.356,1.783a17.53,17.53,0,0,0,2.844,6.846c1.6,2.122,3.383,2.146,4.969.041,1.921-2.55,2.671-5.557,3.229-8.67Zm-2.735-11.42c-2.536,0-5.079-.009-7.622.02a.731.731,0,0,0-.511.454,17.055,17.055,0,0,0-.036,8.129c.107.459.352.52.748.517,1.762-.014,3.523-.006,5.285-.006h2.135Zm16.876,9.112c2.537,0,5.08.009,7.623-.02a.731.731,0,0,0,.51-.455,17.053,17.053,0,0,0,.036-8.128c-.107-.46-.353-.518-.749-.515-1.816.014-3.632.006-5.447.006h-1.971ZM319.349,14.1a16.863,16.863,0,0,0-10.786,9.414H316.2a26.979,26.979,0,0,1,3.146-9.414m20.513,9.428a16.935,16.935,0,0,0-10.817-9.444,27.184,27.184,0,0,1,3.172,9.444ZM316.111,37.289h-7.469c1.42,4.113,7.38,9.289,10.621,9.357-.623-1.475-1.353-2.957-1.877-4.508s-.847-3.184-1.275-4.849m12.832,9.416c4.664-.949,9.691-5.7,10.746-9.44h-7.48a25.186,25.186,0,0,1-3.266,9.44",
    transform: "translate(-16519.553 -19327.266)",
    fill: "#5aa2fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16051",
    "data-name": "Path 16051",
    d: "M348.165,55.433H336.012V46.4h12.142a43.926,43.926,0,0,1,.01,9.035",
    transform: "translate(-16537.477 -19347.787)",
    fill: "#5aa2fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16052",
    "data-name": "Path 16052",
    d: "M337.137,23.481a21.917,21.917,0,0,1,2.736-7.949c1.835-2.95,4.078-2.943,5.914.015a22.2,22.2,0,0,1,2.732,7.935Z",
    transform: "translate(-16538.174 -19327.266)",
    fill: "#5aa2fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16053",
    "data-name": "Path 16053",
    d: "M337.1,76.381h11.4c-.558,3.113-1.308,6.12-3.229,8.67-1.587,2.106-3.369,2.081-4.969-.041a17.53,17.53,0,0,1-2.845-6.846c-.132-.576-.232-1.16-.355-1.783",
    transform: "translate(-16538.152 -19366.391)",
    fill: "#5aa2fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16054",
    "data-name": "Path 16054",
    d: "M315.767,46.291V55.4h-2.135c-1.762,0-3.523-.008-5.285.006-.4,0-.642-.058-.748-.517a17.055,17.055,0,0,1,.036-8.129.731.731,0,0,1,.511-.454c2.543-.03,5.086-.02,7.622-.02",
    transform: "translate(-16519.553 -19347.719)",
    fill: "#5aa2fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16055",
    "data-name": "Path 16055",
    d: "M374.356,55.393V46.28h1.971c1.816,0,3.632.008,5.447-.006.4,0,.643.056.749.515a17.054,17.054,0,0,1-.036,8.128.731.731,0,0,1-.51.456c-2.543.03-5.086.02-7.623.02",
    transform: "translate(-16561.266 -19347.711)",
    fill: "#5aa2fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16056",
    "data-name": "Path 16056",
    d: "M321.7,15.358a26.984,26.984,0,0,0-3.146,9.414h-7.641A16.863,16.863,0,0,1,321.7,15.358",
    transform: "translate(-16521.902 -19328.529)",
    fill: "#5aa2fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16057",
    "data-name": "Path 16057",
    d: "M375.691,24.761h-7.645a27.184,27.184,0,0,0-3.172-9.444,16.935,16.935,0,0,1,10.817,9.444",
    transform: "translate(-16555.383 -19328.504)",
    fill: "#5aa2fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16058",
    "data-name": "Path 16058",
    d: "M318.591,76.464c.429,1.665.75,3.292,1.276,4.849s1.253,3.034,1.877,4.508c-3.241-.069-9.2-5.245-10.621-9.358Z",
    transform: "translate(-16522.033 -19366.441)",
    fill: "#5aa2fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16059",
    "data-name": "Path 16059",
    d: "M364.606,85.843a25.186,25.186,0,0,0,3.266-9.44h7.48c-1.056,3.741-6.082,8.491-10.746,9.44",
    transform: "translate(-16555.217 -19366.404)",
    fill: "#5aa2fb"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.2615a77c1c2e2dc9aa1591954400cf15.svg";
export { ForwardRef as ReactComponent };